import {
  getSessionCookieData,
  isAuthV2Enabled,
} from '@ghl/clientportal-core/init'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

interface IAMV2TokenPayload {
  authClassId: string
  companyId: string
  clientPortalMeta?: {
    locationId: string
    contactId: string
  }
}

let cachedUserId: string | null = null

export function getV2UserId(): string | null {
  if (cachedUserId) return cachedUserId

  if (isAuthV2Enabled()) {
    const cookieData = getSessionCookieData()
    if (!cookieData) return null
    cachedUserId = cookieData.userId || null
    return cachedUserId
  }

  const token =
    Cookies.get('cat-v2') || window.localStorage.getItem('cat-v2') || null
  if (!token) return null
  try {
    const decoded = jwtDecode<IAMV2TokenPayload>(token)
    cachedUserId = decoded.authClassId || null
    return cachedUserId
  } catch {
    return null
  }
}

export function clearCachedUserId(): void {
  cachedUserId = null
}
